<app-navbar></app-navbar>
<div class="ui container">
  <div class="settings-container">
    <div class="ui secondary vertical menu side-nav">
      <a class="item" [routerLink]="['account']" routerLinkActive="active">Account</a>
      <a class="item" [routerLink]="['bgm']" routerLinkActive="active">Bangumi Account</a>
      <a class="item" [routerLink]="['oauth2']" routerLinkActive="active">OAuth2</a>
      <a class="item" [routerLink]="['developer']" routerLinkActive="active">Developer Settings</a>
    </div>
    <div class="children-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

